import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import classNames from 'classnames';
import { ProductPodContext } from '../../ProductPodContext';
import './product-model.scss';

export const ProductModel = () => {
  const { product } = useContext(ProductPodContext);
  const { channel } = useContext(ExperienceContext);

  const { info, identifiers } = product || {};
  const isMobile = channel === 'mobile';
  const { modelNumber } = identifiers || {};
  if (!modelNumber) return null;

  const modelNumberContainer = classNames('product-pod__model', {
    'product-pod__model--brio-mobile': info?.isBrioSku && isMobile
  });

  return (
    <div className={modelNumberContainer}>
      Model# {modelNumber}
    </div>
  );
};

ProductModel.displayName = 'ProductModel';
